module.exports = Promise.all([__parcel__import__("kj9kJ"), __parcel__import__("8doQt")]).then(() => parcelRequire('g36Vt'));